var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.405,
    height: 171.664,
    viewBox: "0 0 133.405 171.664",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rose-p",
    transform: "translate(-1615.551 -429.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_39",
    "data-name": "Trac\\xE9 39",
    d: "M245.172,218.108c-.652-12.167-1.275-24.334-2.258-36.474a12.8,12.8,0,0,0-1.338-4.372,5.241,5.241,0,0,0-7.546-2.172,45.162,45.162,0,0,0-4.3,3.043c-5.9,4.817-11.057,10.721-17.428,14.738-14.326,9.036-15.418,11.026-9.789,26.994.372,1.056.745,2.113,1.15,3.157q5.313,13.642,10.641,27.276c6.293,16.054,9.5,28.44,2.021,44.422a18.382,18.382,0,0,0-1.733,7.346c-.061,5.207,3.592,7.266,7.926,4.378a24.918,24.918,0,0,0,6.529-6.268c10.724-15.358,16.011-28.246,15.674-47.558-.089-5.052.166-13.187.456-18.8a150.028,150.028,0,0,0,0-15.712",
    transform: "translate(1503.077 255.72)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_40",
    "data-name": "Trac\\xE9 40",
    d: "M254.195,310.2a58.725,58.725,0,0,0-12.018-8.518c-13.591-6.821-27.411-13.188-41.152-19.71-1.259-.6-2.588-1.051-3.785-1.532l-15.783-7.5c-5.977-2.365-12.009-4.907-18.149-7.148-9.659-3.524-18.67-2.425-26.357,4.766-8.085,7.565-11.536,16.943-8.983,27.835,3.523,15.03,16.991,25.094,34.716,25.975,22.554,1.123,45.123,1.928,67.689,2.794,5.439.208,10.9.3,16.333.105,4.235-.153,7.742-1.923,9.529-6.129,1.744-4.105,1.225-8.08-2.039-10.941",
    transform: "translate(1488.934 273.265)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeDasharray: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty2);
export default __webpack_public_path__ + "static/media/empty-2.695665856aff302b4d4827f2642ea6a3.svg";
export { ForwardRef as ReactComponent };